import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { uploadPercent } from '../../api/reconFileUpload';
import { uploadReconFile } from '../../api/reconFileUploadClient';
import ReactDropzone from 'react-dropzone';
import './uploadProgress.scss';
import {
	addAttachment,
} from '../../actions/apiAttachments';

class DropBox extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: this.props.value || '', 
			checked: this.props.checked || '', 
			file: '', 
			image: '', 
			image_name: '', 
			image_type: '', 
			mage_size: '', 
			files: [],
			loading: false,
			progress: 0,
		};
		this.onClick = this.onClick.bind(this);
		this.onClickDelete = this.onClickDelete.bind(this);
		this.onDrop = this.onDrop.bind(this);
	}

	uploadFailureMessage(stillUploading) {
		const failures = this.uploadFailures || [];
		if (!failures.length) return '';
		const listed = failures.join('. ');
		if (failures.length >= this.uploadCount) return listed;
		const rest = stillUploading ? 'The other files are still uploading.' : 'The other files were saved.';
		return `${listed}. ${rest}`;
	}

	noteUploadFailure(error) {
		const message = (error && error.message) || 'Upload failed.';
		this.uploadFailures = (this.uploadFailures || []).concat(message);
		this.setState({ uploadError: this.uploadFailureMessage(true) });
	}

	finishUploads() {
		if (!this.uploadActive) return;
		this.uploadActive = false;
		const uploadError = this.uploadFailureMessage(false);
		this.setState({
			loading: false,
			progress: uploadError ? this.state.progress : 100,
			uploadError,
		});
	}

	publishProgress(loaded, totals) {
		if (!this.uploadActive) return;
		const parts = loaded.map((sent, index) => ({ loaded: sent, total: totals[index] }));
		this.setState({ progress: uploadPercent(parts) });
	}

	startUploads(files) {
		const list = files || [];
		if (!list.length) return Promise.resolve();
		this.uploadActive = true;
		this.uploadFailures = [];
		this.uploadCount = list.length;
		const loaded = list.map(() => 0);
		const totals = list.map(file => (file && file.size) || 0);
		this.setState({
			files: list,
			loading: true,
			progress: 0,
			uploadError: '',
		});
		return Promise.all(list.map((file, index) => this.fileUpload(file, (event) => {
			if (!event) return;
			loaded[index] = event.loaded || 0;
			if (event.total) totals[index] = event.total;
			this.publishProgress(loaded, totals);
		}).then(() => {
			loaded[index] = totals[index];
			this.publishProgress(loaded, totals);
		}).catch((error) => {
			this.noteUploadFailure(error);
		}))).then(() => {
			this.finishUploads();
		}).catch(() => {
			this.finishUploads();
		});
	}

	renderProgress() {
		const label = this.state.progress < 100 ? 'Uploading...' : 'Complete!';
		return (
			<div className="card-header bg-grey text-white text-capitalize">
				<div
					className="upload-progress form-control"
					role="progressbar"
					aria-label="Upload progress"
					aria-valuenow={this.state.progress}
					aria-valuemin="0"
					aria-valuemax="100"
					aria-busy="true"
				>
					<div className="upload-progress-fill" id="dropbox-progress" style={{ width: `${this.state.progress}%` }} />
					<span className="upload-progress-label">{label}</span>
				</div>
			</div>
		);
	}

	renderDrop() {
		return (
			<ReactDropzone className="drop-box p-2 text-center space-top-1 btn btn-success form-control" onDrop={this.onDrop}>
				{({ getRootProps, getInputProps }) => (
					<section>
						<div {...getRootProps()}>
							<input {...getInputProps()} />
							<div className="card-header bg-grey text-white text-capitalize">
								<button type="button" className="btn btn-success form-control">Drop/Add Files</button>
							</div>
						</div>
					</section>
				)}
			</ReactDropzone>
		);
	}

	onDrop(files) {
		this.startUploads(files);
	}

	onClick() {
		const { files } = this.state;
		this.setState({ files: [] });
		this.startUploads(files);
	}

	onClickDelete(name) {
		const newFiles = this.state.files.filter(el => el.name !== name);
		this.setState({
			files: newFiles || [],
		});
	}

	uploadData(response, fileid, siteid = this.props.siteid) {
		const fileurl = typeof response.data === 'string' ? response.data.trim() : response.data;
		const errorType = 'addAttachmentError';
		const { vid } = this.props;
		const { user_name } = this.props;
		const { uid } = this.props;

		const data = {
			vehicle_id: vid,
			filename: fileid,
			location: fileurl,
			fileid,
			siteid,
			user_name,
			uid,
		};

		return this.props.addAttachment(data, errorType);
	}

	fileUpload(file, onProgress) {
		const url = "https://gotoreconfiles.com/cors_new_server.php";

		const { siteid } = this.props;
		const fileid = file.name.replace(/#/g, '');
		const postPhp = () => {
			const data = new FormData();
			data.append('data', file);
			data.append('action', 'put-newserver-file');
			data.append('fileid', fileid);
			data.append('siteid', siteid);

			return axios.post(url, data, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
				onUploadProgress: onProgress,
			}).then(response => this.uploadData(response, fileid));
		};

		return uploadReconFile({
			kind: 'attachment',
			file,
			vehicleId: this.props.vid,
			onProgress,
		}).then((uploaded) => {
			if (!uploaded) return postPhp();
			return this.uploadData({ data: uploaded.url }, uploaded.fileid, uploaded.siteid);
		});
	}

	render() {
		return (
			<div>
				<div className="dropzone">
					{this.state.loading ? this.renderProgress() : this.renderDrop()}
				</div>
				{this.state.uploadError ? <p className="text-danger mb-0">{this.state.uploadError}</p> : null}
			</div>
		);
	}
}

const mappedActions = {
	addAttachment,
};

function mapStateToProps(state) {
	return { user_name: state.current_user.user_name,
		uid: state.current_user.user, };
}

export default connect(mapStateToProps, mappedActions)(DropBox);
